import React from "react";
import { AlertTriangle, Phone } from "lucide-react";
import { contactInfo } from "../mock";
import { useLanguage } from "../contexts/LanguageContext";

const Emergency = () => {
  const { t } = useLanguage();

  return (
    <section className="mag-emergency">
      <div className="mag-emergency-inner reveal">
        <div
          style={{
            width: 70,
            height: 70,
            borderRadius: "50%",
            background: "rgba(234,97,97,0.15)",
            border: "2px solid #ea6161",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: 24,
            color: "#ea6161",
          }}
        >
          <AlertTriangle size={32} />
        </div>
        <h2>{t.emergency.title}</h2>
        <p>{t.emergency.subtitle}</p>
        <div className="mag-emergency-ctas">
          <a
            href={`tel:${contactInfo.phones[0].replace(/\s+/g, "")}`}
            className="btn btn-primary btn-lg"
          >
            <Phone size={20} />
            {t.emergency.ctaEmergency} {contactInfo.phones[0]}
          </a>
        </div>
      </div>
    </section>
  );
};

export default Emergency;
